module.exports = __webpack_public_path__ + "img/dl-btn-android.0eac6ba2.svg";